import React from "react";
import ConciergeLogo from "../../assets/images/conciergeLogoLight.svg";
import "../../views/BookingFlow/BookingFlow.css";

const GlobalHeader = () => {
  return (
    <div className="global-header">
      <div className="header-content">
        <div className="promo-message">
          <span className="promo-text">$10 off any booking over $100</span>
          <span className="promo-subtext">
            Automatically applied at the checkout
          </span>
        </div>
      </div>
    </div>
  );
};

export default GlobalHeader;
